<template>

  <div  :class="['borderR5', 'mt-3', !selected.vessel.images[0] ? 'vslimgcont':'']">
    <Images></Images>
      <table class="vsl-table">
        <tr>
          <td>{{lng.name }}:</td>
          <td><strong>{{selected.vessel.name}}</strong></td>
        </tr>
        <tr>
            <td>{{lng.grt }}:</td>
            <td>{{selected.vessel.grt}}</td>
        </tr>

        <tr>
          <td>{{lng.built}}: </td>
          <td>{{selected.vessel.built_year}}</td>
        </tr>

        <tr>
          <td>{{lng.main_engine }}: </td>
          <td>{{selected.vessel.main_engine}}</td>
        </tr>

        <tr>
          <td>{{lng.engine_type }}:</td>
          <td>{{selected.vessel.engine_type}}</td>
        </tr>

        <tr>
          <td>{{lng.trading_area }}:</td>
          <td>{{selected.vessel.trading_area}}</td>
        </tr>

        <tr>
          <td> {{ lng.flag }}:</td>
          <td><span :class="flagBoxClass"></span>{{flags.name}}</td>
        </tr>
        <tr>
          <td> {{ lng.shipowner }}:</td>
          <td><span :class="flagOwner"></span>{{shipOwner.name}} </td>
        </tr>

        <tr>
          <td>{{lng.nationalities}}:</td>
          <td>{{snats}}</td>
        </tr>
        
        <tr>
          <td>{{lng.internet}}:</td>
          <td>{{selected.vessel.wifi == 1 ? "\u2713" : "\u20E0"}}</td>
        </tr>
      </table>
</div>

</template>



<script>
import {mapGetters, mapActions} from 'vuex'
import Images from './Images.vue'

export default {

  components: {
    Images
  },
  
  data(){
    return {
        pvt: 0,
        shipOwner: {},
        flags: {},
        nats: {}
      }
  },
  updated() {
      this.getShipOwner()
  },
  computed: {
        ...mapGetters(['lng',
                'isLoaded',
                'show',
                'selected',
                'vesselsType',
                'fleets',
                'countries'
              ]),
        snats(){
            return this.nats.length ? this.nats.map(({ name }) => name).join(', ') : 'Not Provided';
        },
        flagBoxClass(){
             if(this.flags &&  Object.keys(this.flags).length ) {
                  let cl = this.flags.short_name;
                return 'flag flag-'+cl.toLowerCase();
            }
            return ''
        },
      flagOwner(){
          if(this.shipOwner &&  Object.keys(this.shipOwner).length ) {
              let cl = this.shipOwner.short_name;
              return 'flag flag-'+cl.toLowerCase();
          }
          return ''
      }


    },
  methods: {

          getShipOwner(){
             this.shipOwner = this.countries.filter( c => c.id === this.selected.vessel.shipowner)[0];
             this.flags = this.countries.filter( c => c.id === this.selected.vessel.flag)[0];
             this.nats = this.selected.vessel.nationalites;
          }

     },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .flag {
    opacity: 1.0;
    top: -1px;
    margin-right: 5px;
  }
.nationalites {
  height: auto!important;
}
.multiselect-box {
   width: 200px;
   float: right;

}

.selected-flag {
  margin-left: 125px;
}


.multiselect-box .multiselect__select{
    top: auto;
    bottom: 12px;
    display:none;
}
.multiselect-box .multiselect--active .multiselect__select{
  bottom: 5px;
}
.multiselect-box .multiselect__tags {
  padding: 0;
  border: none;
}
.multiselect-box .multiselect__tags  .multiselect__input {
    width: 100% !important;
    position: relative !important;
    padding-left: 12px !important;
}

.multiselect__single {
    position: absolute;
    bottom: 9px;
    left: 6px;
    width: calc(100% - 12px);
    line-height: 32px;
    height: 30px;
    margin-bottom: 0;
    padding-left: 6px;
}
.multiselect__content-wrapper {overflow-x: hidden;}
.multiselect__content-wrapper::-webkit-scrollbar {
  display: none;
}
.multiselect__tags-wrap {
  position: absolute;
  top: 100%;
}
.vsl-table {
  margin: 20px;
  table-layout: fixed;
}
.vsl-table tr{
  height: 20px;
}

@media (max-width:768px){
  .vsl-table {
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// VesselForm.vue?3d95668d